<template lang="pug">
  .report
    label.fs-17(style="font-weight: bold;") opções extras
    .flex
      PCheckbox(v-model="reportOptions.resignation" :label="`Não considerar ${$wp('employee')} demitidos`")

      PCheckbox(v-model="reportOptions.timelog" :label="`Não considerar ${$wp('employee')} sem pontos no mês`")

      PCheckbox(v-model="reportOptions.merged" label="Gerar resultado em um arquivo")

      PCheckbox(v-model="reportOptions.oneEmployeePerFile" :label="`Um arquivo por ${$ws('employee')}`")

      PCheckbox(v-model="reportOptions.generateDelivery" label="Não gerar relatório de entrega")

      PCheckbox(v-model="reportOptions.atestados" label="Anexar atestados na folha")

      PCheckbox(v-model="reportOptions.showWorkHoursBank" label="Mostrar banco de horas")

      PCheckbox(v-model="reportOptions.showComments" label="Mostrar em Observações as notas adicionadas")

      PCheckbox(
        v-if="tabelaMovimentacaoDeFolha"
        v-model="reportOptions.mostrarTabelaMovimentosDaFolha"
        label="Mostrar tabela com movimentações da folha"
      )

    hr
    Accordion(:startOpen="false")
      template(slot="heading")
        span.fs-19(style="text-align: center;") omitir campos
      template
        .flex
          PCheckbox(v-model="reportOptions.fieldsOmit.admission" label="admissão")
          PCheckbox(v-model="reportOptions.fieldsOmit.cpf" label="cpf")
          PCheckbox(v-model="reportOptions.fieldsOmit.rg" label="rg")
          PCheckbox(v-model="reportOptions.fieldsOmit.department" label="departamento")
          PCheckbox(v-model="reportOptions.fieldsOmit.company" :label="$ws('companyShortName')")

    hr
    .flex
      PSelect(:options="[{id: 'company', name: this.$ws('companyShortName')}, {id: 'employer', name: 'empregador'}]"
        v-model="reportOptions.groupBy" labelItem="name" title="agrupar por" :allowEmpty="false")

      PSelect(:options="[{id: 'name', name: 'nome'}, {id: 'code', name: 'código'}]"
        v-model="reportOptions.orderBy" labelItem="name" title="ordenar por" :allowEmpty="false")

    .button
      PButton(color="success" size="md" @click="generate" :loading="loading" :disabled="!valid") gerar

</template>

<script>
import { setAmplitudeEvent } from 'src/amplitudeUtils'
export default {
  props: {
    reportInfo: {type: Object},
    valid: {type: Boolean}
  },
  data () {
    return {
      loading: false,
      reportOptions: {
        groupBy: 'company',
        orderBy: 'name',
        fieldsOmit: {company: false, cpf: false, admission: false, rg: false, department: false},
        resignation: false,
        timelog: false,
        merged: false,
        oneEmployeePerFile: false,
        generateDelivery: false,
        atestados: false,
        showWorkHoursBank: false,
        showComments: false,
        mostrarTabelaMovimentosDaFolha: false
      }
    }
  },
  computed: {
    tabelaMovimentacaoDeFolha () {
      return this.$store.state.userInfo.compMan.tabelaMovimentacaoDeFolha
    }
  },
  methods: {
    getOptions () {
      return this.reportOptions
    },
    async generate () {
      if (!this.valid) return

      this.loading = true

      let result

      try {
        result = await this.$API.R01.save({
          entity: this.reportInfo.entity,
          entityContent: this.reportInfo.entityContent.map(i => i.id),
          beta: [],
          compMan: this.$store.state.userInfo.compMan.id,
          groupBy: 'company',
          orderBy: 'name',
          showRoutine: false,
          ...this.reportOptions,
          generateDelivery: !this.reportOptions.generateDelivery,
          ...(
            this.reportInfo.periodData.type === 'period'
              ? {dateStart: this.reportInfo.periodData.startDate, dateEnd: this.reportInfo.periodData.endDate}
              : {year: this.reportInfo.periodData.year, month: this.reportInfo.periodData.month}
          )
        })
        setAmplitudeEvent('gera relatorio R01', {})
      } catch (e) {
        result = e
      }
      this.$emit('handleReport', result)

      this.loading = false
    }
  }
}
</script>

<style scoped lang="scss">
.report {
  display: grid;
  grid-row-gap: 10px;

  .flex {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 20px;
  }
  .button {
    justify-self: end;
    margin-bottom: 100px;
  }
}
</style>
